@use "@fukuri-admins/ui/layout" as *;

$Primary: #21e4a3;

.LegacyDashboardLayout {
  display: flex;
  background-color: $BackgroundGray;
  padding-left: $SideMenuWidth;
  min-height: 100vh;
  @media screen and (max-width: $TB) {
    flex-direction: column;
    padding-left: 0;
    padding-top: 40px;
  }
  &__SideMenuFooter {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    text-align: center;
    color: $White;
    font-weight: 600;
    background-color: $Primary;
    font-size: 16px;
    @media screen and (max-width: $TB) {
      display: none;
    }
  }
}

